<div class="ukcc-product" [class.mobile-native]="isNativeAppVisible">
  <app-header></app-header>

  <app-shared-product></app-shared-product>

  <app-footer></app-footer>
</div>
